import { render } from "./AppPanels.vue?vue&type=template&id=5610f065&scoped=true"
import script from "./AppPanels.vue?vue&type=script&lang=js"
export * from "./AppPanels.vue?vue&type=script&lang=js"

import "./AppPanels.vue?vue&type=style&index=0&id=5610f065&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5610f065"]])

export default __exports__